<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @set-nc="setNc"
      @checkboxChange="(e) => (checkedRow = e)"
      @openChooseAssignment="openChooseAssignment"
      @updateFactoryOrderNo="updateFactoryOrderNo"
      @rollbackNCStatus="rollbackNCStatus"
    >
      <page-header
        :checkedCount="checkedCount"
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openChooseAssignment="openChooseAssignment"
        @updateFactoryOrderNo="updateFactoryOrderNo"
        @clearCheckboxRow="clearCheckboxRow"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <SetNcForm
      :visible.sync="setNcFormOptions.visible"
      :noticeOrderCode="setNcFormOptions.code"
      @reload="reload"
    />
    <BatchUpdateBizPerson
      ref="batchUpdateBizPerson"
      v-if="updateBizPersonOptions.visible"
      :visible.sync="updateBizPersonOptions.visible"
      @confirm="onConfirm"
    />
    <BatchUpdateFactory
      ref="batchUpdateFactory"
      v-if="updateFactoryOptions.visible"
      :visible.sync="updateFactoryOptions.visible"
      :factoryOrderNo="updateFactoryOptions.factoryOrderNo"
      @confirm="factoryConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import SetNcForm from '../set-nc-form'
import EditLoading from '@/mixins/edit-loading'
import BatchUpdateBizPerson from '../batch-update-biz-person'
import BatchUpdateFactory from '../batch-update-factory'
export default {
  components: {
    PageHeader,
    PageMain,
    SetNcForm,
    BatchUpdateBizPerson,
    BatchUpdateFactory,
  },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      setNcFormOptions: { visible: false, code: '' },
      updateBizPersonOptions: { visible: false },
      updateFactoryOptions: { visible: false, factoryOrderNo: '' },
      checkedRow: [],
      updateRow: [],
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    async rollbackNCStatus(param) {
       const confirm = await this.$confirm(
        "确定回退NC赋码状态吗？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => true)
        .catch(() => false);

      if (!confirm) return;
      this.loadingOpen()
      this.$api
        .noticeOrderBackNoticeOrderStatusApi(param)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status == 200) {
            this.$message({
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success',
            })
            this.reload()
          }
        })
        .catch(() => {
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          this.loadingClose()
        })
    },
    openChooseAssignment(noticeData) {
      this.updateRow = noticeData?.length > 0 ? noticeData : this.checkedRow
      this.updateBizPersonOptions.visible = true
    },
    updateFactoryOrderNo(noticeData) {
      this.updateRow = noticeData?.length > 0 ? noticeData : this.checkedRow
      this.updateFactoryOptions.factoryOrderNo = ''
      if (this.updateRow.length == 1) {
        this.updateFactoryOptions.factoryOrderNo = this.updateRow[0].factoryOrderNo
      }
      this.updateFactoryOptions.visible = true
    },
    onCheckboxChange(e) {
      this.checkedRow = e
    },
    clearCheckboxRow() {
      this.$refs.main.clearCheckboxRow()
    },
    onConfirm(param) {
      const noticeOrderCodes = this.updateRow.map((e) => e.noticeOrderCode)
      this.loadingOpen()
      this.$api
        .noticeOrderBatchUpdateBizPersonApi({
          ...param,
          noticeOrderCodes,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status == 200) {
            this.$message({
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success',
            })
            this.$refs.batchUpdateBizPerson.close()
            this.updateRow = []
            this.updateBizPersonOptions.visible = false
            this.clearCheckboxRow()
            this.reload()
          }
        })
        .catch(() => {
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          this.loadingClose()
        })
    },
    factoryConfirm(param) {
      const noticeOrderCodes = this.updateRow.map((e) => e.noticeOrderCode)
      this.loadingOpen()
      this.$api
        .noticeOrderBatchUpdateFactoryApi({
          ...param,
          noticeOrderCodes,
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status == 200) {
            this.$message({
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success',
            })
            this.updateRow = []
            this.updateFactoryOptions.visible = false
            this.updateFactoryOptions.factoryOrderNo = ''
            this.clearCheckboxRow()
            this.reload()
          }
        })
        .catch(() => {
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          this.loadingClose()
        })
    },
    getData(form) {
      this.loading = true
      this.$api
        .noticeOrderListByNewApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    setNc(code) {
      this.setNcFormOptions = { visible: true, code }
    },
  },
}
</script>
